import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import PropTypes from "prop-types";

const BasicTable = ({ columns = [], rows = [] }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ overflowX: "auto" }}
    >
      <Table sx={{ borderCollapse: "collapse", border: "2px solid #E0E0E0", minWidth: "500px" }}>
        <TableHead>
          <TableRow sx={{ background: "#FAFAFA" }}>
            {columns.map((column) => (
              <TableCell
                key={column.field || column.header}
                sx={{
                  fontSize: "16px",
                  border: "2px solid #E0E0E0",
                }}
              >
                {column.header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const rowKey = row.id || row.code || JSON.stringify(row);

            return (
            <TableRow key={rowKey}>
              {columns.map((column) => (
                <TableCell
                  key={`${rowKey}-${column.field || column.header}`}
                  sx={{
                    fontSize: "16px",
                    borderRight:
                      column !== columns[columns.length - 1]
                        ? "2px solid #E0E0E0"
                        : "none",
                  }}
                >
                  {row[column.field]}
                </TableCell>
              ))}
            </TableRow>
          );})}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

BasicTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      field: PropTypes.string,
    })
  ),
  rows: PropTypes.arrayOf(PropTypes.object),
};

export default BasicTable;
